/* eslint-disable no-param-reassign */
import breadcrumbSchema from '../schemas/breadcrumb';

const batchSubTopicsSchema = ({ goal = {}, others = [] }) => {
  const graph = [];
  const breads = [
    {
      name: 'Explore',
      url: 'https://unacademy.com/explore'
    }
  ];
  if (goal?.name && goal?.permalink) {
    breads.push({
      name: goal.name,
      url: goal.permalink
    });
    breads.push({
      name: 'Batches',
      url: `${goal.permalink}/batches`
    });
  }
  if (others.length > 0) {
    others.forEach((other) => {
      breads.push(other);
    });
  }
  graph.push(breadcrumbSchema(breads));
  const schema = {
    '@context': 'https://schema.org/',
    '@graph': graph
  };
  return schema;
};

export default batchSubTopicsSchema;
